export const GET_LIST = 'quotation-GET_LIST';
export const GET_DETAILS = 'quotation-GET_DETAILS';
export const GET_DETAILS_CHANGES = 'quotation-GET_DETAILS_CHANGES';
export const REQUEST_PRICING = 'quotation-REQUEST_PRICING';
export const REQUEST_PRICING_INITIAL = 'quotation-REQUEST_PRICING_INITIAL';
export const CREATE_QUOTATION = 'quotation-CREATE_QUOTATION';
export const REQUEST_QUOTATION_CLONE = 'quotation-REQUEST_QUOTATION_CLONE';
export const REQUEST_QUOTATION_COPY = 'quotation-REQUEST_QUOTATION_COPY';
export const DOWNLOAD_INSPECTION_REPORT =
  'quotation-DOWNLOAD_INSPECTION_REPORT';
export const DOWNLOAD_VEHICLE_REGISTRY = 'quotation-DOWNLOAD_VEHICLE_REGISTRY';
export const INSPECCION_TRANSFER = 'inspection/transfer';
export const REQUEST_LICENSEPLATE =
  'Quotation/vehicles/models/REQUEST_LICENSEPLATE';
export const REQUEST_SUBAGENTS = 'Quotation/REQUEST_SUBAGENTS';
export const GET_PLANS_REQUEST = 'GET_PLANS_REQUEST';
